export const SpecialFederationName = {
    FFA: 'FFA',
    FFTRI: 'FFTRI',
    FFS: 'FFS'
};
